import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import style from './HelloWorld.module.css';
import { embedDashboard } from "@superset-ui/embedded-sdk";

const HelloWorld = ({ supersetDomain, dashboardId, institutionId, currentCycle }) => {

  async function fetchGuestToken() {
    const response = await fetch(`/institutions/${institutionId}/dashboard/aggregate/generate_guest_token`);
    const data = await response.json();
    return data.token;
  }

  useEffect(() => {
    const ictDropdown = document.getElementById('topic-dropdown');
    let selectedTopic = ictDropdown.options[ictDropdown.selectedIndex].value;

    async function embed() {
      const guestToken = await fetchGuestToken();

      if (guestToken) {
        document.getElementById("superset").style.display = 'block';
        document.getElementById("content").style.height = '100%';
        document.getElementById("aggregate").style.height = '100%';

        embedDashboard({
          id: dashboardId,
          supersetDomain: supersetDomain + `/embedded/${dashboardId}?uiConfig=1&expand_filters=true&topic_id=${selectedTopic}&institution_id=${institutionId}&cycle=${currentCycle}&standalone=3&show_filters=0`,
          mountPoint: document.getElementById("superset-iframe-container"),
          fetchGuestToken: () => Promise.resolve(guestToken),
          dashboardUiConfig: { hideTitle: true }
        })

      } else {
        document.getElementById("chart-js").style.display = 'block';
      }
    }

    embed();

    const handleChange = () => {
      selectedTopic = ictDropdown.options[ictDropdown.selectedIndex].value;
      embed();
    };

    ictDropdown.addEventListener('change', handleChange);

    // Clean up the event listener on component unmount
    return () => {
      ictDropdown.removeEventListener('change', handleChange);
    };

  }, [supersetDomain, dashboardId]);

  return (
    <div id="superset-iframe-container" style={{ width: '100%', height: '100%' }}>
      {/* Dashboard will be embedded here */}
    </div>
  );
};

HelloWorld.propTypes = {
  supersetDomain: PropTypes.string.isRequired, // this is passed from the Rails view
  dashboardId: PropTypes.string.isRequired
};

export default HelloWorld;
